import Cookies from 'universal-cookie';
import createDataContext from './createDataContext';
import authApi from '../api/auth';
import signInApi from '../api/signIn';
import history from '../history';

const cookies = new Cookies();

const authReducer = (state, action) => {
  switch (action.type) {
    case 'add_error':
      return {
        ...state,
        errorTitle: action.payload.errorTitle,
        errorMessage: action.payload.errorMessage,
      };
    case 'signin':
      return { ...state, user: action.payload, errorMessage: '' };
    case 'authenticate_token':
      return { ...state, user: action.payload, errorMessage: '' };
    case 'clear_error_message':
      return { ...state, errorTitle: '', errorMessage: '' };
    case 'sign_out':
      return { ...state, errorTitle: '', errorMessage: '' };
    case 'update':
      return { ...state, user: action.payload, errorMessage: '' };
    case 'update_password':
      return { ...state, errorMessage: action.payload };
    default:
      return state;
  }
};

//TODO: Create route to get user with token.
const tryLocalSignin = (dispatch) => async () => {
  if (!cookies.get('token')) return;
  try {
    const response = await authApi.get('/user');
    dispatch({ type: 'authenticate_token', payload: response.data });
    history.push('/dashboard/home');
  } catch (err) {
    console.log(err);
    history.push('/');
  }
};

const clearErrorMessage = (dispatch) => () => {
  dispatch({ type: 'clear_error_message' });
};

const update =
  (dispatch) =>
  async ({
    first_name,
    last_name,
    title,
    email,
    password,
    newPassword,
    university,
    university_name,
  }) => {
    try {
      const response = await authApi.post('/user', {
        first_name,
        last_name,
        title,
        email,
        password,
        newPassword,
        university,
        university_name,
      });
      dispatch({ type: 'update', payload: response.data.user });
      return true;
    } catch (err) {
      dispatch({
        type: 'add_error',
        payload: 'Something went wrong with sign up',
      });
    }
  };

const updatePassword =
  (dispatch) =>
  async ({ id, current_password, new_password, new_password_2 }) => {
    try {
      const response = await authApi.put(`/change_password/${id}`, {
        current_password,
        new_password,
        new_password_2,
      });
      if (response) {
        return true;
      }
    } catch (error) {
      dispatch({
        type: 'add_error',
        payload: 'Your current password is incorrect',
      });
    }
  };

const updateEmailPreferences =
  (dispatch) =>
  async ({ id, newsletter }) => {
    try {
      const response = await authApi.post(`/user`, {
        id,
        newsletter,
      });
      if (response) {
        return true;
      }
    } catch (error) {
      dispatch({
        type: 'add_error',
        payload: 'Something went wrong, please try again',
      });
    }
  };

const signin =
  (dispatch) =>
  async ({ email, password }) => {
    if (!email || !password) {
      dispatch({
        type: 'add_error',
        payload: {
          errorTitle: 'Enter email and password',
          errorMessage: `If you don't have an account yet, select <strong>Create account</strong>`,
        },
      });
    }
    try {
      const response = await signInApi.post('/login', { email, password });
      await cookies.set('token', `${response.data.token}`);

      dispatch({ type: 'signin', payload: response.data.user });
      history.push('/dashboard/home');
    } catch (err) {
      let errType = err.response.data.type ? err.response.data.type[0] : '';
      if (errType === 'not_validated') {
        dispatch({
          type: 'add_error',
          payload: {
            errorTitle: 'Account not activated',
            errorMessage: `We're still working to verify your credentials.  If we're not in touch soon, please <a class="hover:cursor-pointer hover:underline" href="mailto:sims.admin@dmsinetwork.com">contact us</a>.`,
          },
        });
      } else if (errType === 'incorrect_password') {
        dispatch({
          type: 'add_error',
          payload: {
            errorTitle: `Incorrect password.  ${err.response.data.login_attempts_remaining[0]} attempts remaining`,
            errorMessage:
              'After five failed attempts to log in, your account will be locked for 15 minutes.  To reset your password, select <strong>Forgot password</strong> below.',
          },
        });
      } else if (errType === 'account_locked') {
        dispatch({
          type: 'add_error',
          payload: {
            errorTitle: `Account Locked`,
            errorMessage: `Your account is now locked.  Please wait 15 minutes before trying to log in again.  If you continue to have trouble logging in, select <strong>Forgot password</strong> below, or <a class="hover:cursor-pointer hover:underline" href="mailto:sims.admin@dmsinetwork.com">contact us</a>.`,
          },
        });
      }
    }
  };

const signout = (dispatch) => async () => {
  try {
    const response = await authApi.post('/logout', {});
    if (response) {
      await cookies.remove('token', {
        path: '/',
        domain: 'localhost',
      });
      dispatch({ type: 'sign_out' });
      history.push('/');
    }
  } catch (err) {
    dispatch({
      type: 'add_error',
      payload: 'Something went wrong with signout',
    });
  }
};

export const { Provider, Context } = createDataContext(
  authReducer,
  {
    signin,
    update,
    updatePassword,
    updateEmailPreferences,
    signout,
    clearErrorMessage,
    tryLocalSignin,
  },
  { user: null, errorTitle: '', errorMessage: '' }
);
